import { Preferences } from '@capacitor/preferences';
import { CookiesInterface } from './cookies';

export class CookiesNative implements CookiesInterface {
  async hasCookie(name: string): Promise<boolean> {
    const { value } = await Preferences.get({ key: name });
    return value !== null;
  }

  async getCookie(name: string): Promise<string | undefined> {
    const { value } = await Preferences.get({ key: name });
    if (value !== null) {
      return value;
    }
    return undefined;
  }

  async deleteCookie(name: string): Promise<void> {
    await Preferences.remove({ key: name });
  }

  async setCookie(name: string, value: string, days: number): Promise<void> {
    await Preferences.set({ key: name, value });
  }
}
